module.exports = __webpack_public_path__ + "img/charging-stations-night.a70dfc2c.png";